

const dropdownItems = [
    { value: "I&R COAX Tech", name: "I&R COAX Tech" },
    { value: "I&R FIBER Tech", name: "I&R FIBER Tech" },
    { value: "I&R COAX/FIBER Tech", name: "I&R COAX/FIBER Tech" },
    { value: "Drop Bury Crew Without Boring", name: "Drop Bury Crew Without Boring" },
    { value: "Drop Bury Crew With Boring", name: "Drop Bury Crew With Boring" },
    { value: "Underground Fiber Construction", name: "Underground Fiber Construction" },
    { value: "Underground COAX Construction", name: "Underground COAX Construction" },
    { value: "Underground Fiber/COAX Construction", name: "Underground Fiber/COAX Construction" },
    { value: "Aerial Fiber Construction", name: "Aerial Fiber Construction" },
    { value: "Aerial COAX Construction", name: "Aerial COAX Construction" },
    { value: "Aerial Fiber/COAX Construction", name: "Aerial Fiber/COAX Construction" },
];

export {
    dropdownItems,
  
};